import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { AiFillHome, AiOutlineInfoCircle, AiOutlineLogin } from "react-icons/ai";
import { FaShieldAlt } from "react-icons/fa";

import logo from '../assets/images/logo/logo_bpm.png';
import logoUnggul from '../assets/images/logo/logo_unggul.png';
import logoGift from '../assets/images/logo/logo_gift.png';
import logoDikti from '../assets/images/logo/logo_dikti.png';
import logoIso from '../assets/images/logo/logo_iso_panjang.png';
import logoThe from '../assets/images/logo/logo_the.png';
import logoTheB from '../assets/images/logo/logo_theB.png';
import logoQs from '../assets/images/logo/logo_qs.png';
import logoUnismuh from '../assets/images/logo/logo_unismuh.png';
import logoUiGreen from '../assets/images/logo/logo-uigreen.png';
import background from '../assets/images/bg/back-v1.png';

// import '../assets/scss/app.scss';
// import '../assets/scss/wave-header.scss';

const HorizontalLayout = ({
    children
}) => {
    const location = useLocation();

    return (
        <div id="main" className="layout-horizontal" style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover', minHeight: '100vh' }}>
            <header className="mb-3">
                <div className="header-top">
                    <div className="container ">
                        <div className="logo d-flex align-items-center">
                            <a href="#" className="me-3">
                                <img src={logo} alt="Logo" srcSet="" style={{height:'50px'}} />
                            </a>
                            <div className="logo-text d-none d-md-block" style={{lineHeight: '0.4'}}>
                                <h4 className="mb-0 text-primary fw-bold" style={{fontSize: '1.8rem', marginBottom: '-2px'}}>SISPENMU</h4>
                                <small className="text-muted" style={{fontSize: '0.8rem'}}>Universitas Muhammadiyah Makassar</small>
                            </div>
                        </div>
                        <div className="header-top-right">
                            <div className="d-none d-lg-block me-3" style={{ 
                                width: '600px', 
                                overflow: 'hidden',
                                position: 'relative'
                            }}>
                                <div className="infinite-logo-slider">
                                    <div className="logo-track">
                                        <img src={logoUnismuh} alt="Unismuh" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoUnggul} alt="Unggul Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoGift} alt="Gift Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoDikti} alt="Dikti Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoIso} alt="ISO Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoTheB} alt="THEB Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoThe} alt="THE Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoQs} alt="QS Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoUiGreen} alt="UI Green Metric" style={{height:'50px', margin: '0 15px'}} />
                                        {/* Duplicate for seamless loop */}
                                        <img src={logoUnismuh} alt="Unismuh" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoUnggul} alt="Unggul Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoGift} alt="Gift Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoDikti} alt="Dikti Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoIso} alt="ISO Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoTheB} alt="THEB Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoThe} alt="THE Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoQs} alt="QS Logo" style={{height:'50px', margin: '0 15px'}} />
                                        <img src={logoUiGreen} alt="UI Green Metric" style={{height:'50px', margin: '0 15px'}} />
                                    </div>
                                </div>
                            </div>

                            {/*Burger button responsive*/}
                            <a href="#" className="burger-btn d-block d-xl-none">
                                < i className="bi bi-justify fs-3" />
                            </a>
                        </div>
                    </div>
                </div>
                <nav className="main-navbar">
                    <div className="container">
                        <ul className="d-flex justify-content-between align-items-center w-100">
                            <li className={`menu-item ${location.pathname === '/' ? 'active' : ''}`}>
                                <Link to="/" className="menu-link">
                                    <AiFillHome className="me-2" />
                                    <span>Beranda</span>
                                </Link>
                            </li>
                            <li className={`menu-item ${location.pathname === '/deskripsi' ? 'active' : ''}`}>
                                <Link to="/deskripsi" className="menu-link">
                                    <AiOutlineInfoCircle className="me-2" />
                                    <span>Deskripsi</span>
                                </Link>
                            </li>
                            <li className={`menu-item ${location.pathname === '/kebijakan' ? 'active' : ''}`}>
                                <Link to="/kebijakan" className="menu-link">
                                    <FaShieldAlt className="me-2" />
                                    <span>Kebijakan</span>
                                </Link>
                            </li>
                            <li className="menu-item ms-auto me-3">
                                <a href="https://sim.sispenmu.unismuh.ac.id" target="_blank" rel="noopener noreferrer" className="menu-link">
                                    <AiOutlineLogin className="me-2" />
                                    <span>LOGIN</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>

            </header>

            <style jsx="true">{`
                @keyframes scroll-left {
                    0% {
                        transform: translateX(0);
                    }
                    100% {
                        transform: translateX(-50%);
                    }
                }

                .infinite-logo-slider {
                    width: 100%;
                    display: flex;
                    align-items: center;
                }

                .logo-track {
                    display: flex;
                    align-items: center;
                    animation: scroll-left 30s linear infinite;
                    white-space: nowrap;
                }

                .logo-track:hover {
                    animation-play-state: paused;
                }
            `}</style>

            <div className="content-wrapper container">
                {children}
            </div>

            <footer>
                <div className="container mt-4">
                    <div className="footer clearfix mb-0 text-muted">
                        <div className="float-start">
                            <p>2025 - {new Date().getFullYear()} &copy; Badan Penjaminan Mutu</p>
                        </div>
                        <div className="float-end">
                            <p>Developed by <span className="text-primary"><i className="bi bi-code-slash"></i></span> <a
                                href="https://lsit.unismuh.ac.id">LSIT</a></p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default HorizontalLayout;

HorizontalLayout.prototype = {
  children : PropTypes.element
};

HorizontalLayout.defaultProps = {
    children : <></>
};